import { createStore } from 'hox';
import { useState } from 'react';
import { RoleTarget } from '@Types/administrator';

export const [useRoleUsersStore, RoleUsersStoreProvider] = createStore(() => {
  const [roleTargets, setRoleTargets] = useState<RoleTarget[] | null>(null);
  const [leftCheckedRoleUsers, setLeftCheckedRoleUsers] = useState<
    RoleTarget[] | null
  >(null);
  return {
    roleTargets,
    setRoleTargets,
    leftCheckedRoleUsers,
    setLeftCheckedRoleUsers,
  };
});
